/*
 * Public API Surface of inova-core
 */

export * from './user-customization.service'


